import { fuzzyMatch } from '../../../../app/helpers/fuzzy-match';
import { stripHtml } from '../../../../core/util/utils';
import { Lookup } from '../../../business-objects/lookup/lookup.model';
import { TextControlSearchValueEnum } from '../text-control-search-value.enum';
import { SearchResultModel } from './search-result.model';

export const getInputValueFromLookup = (
    result: SearchResultModel,
    mode: TextControlSearchValueEnum
): string => {

    if (!result) {
        return '';
    }

    switch (mode) {
        case TextControlSearchValueEnum.TITLE: {
            return result.text;
        }
        case TextControlSearchValueEnum.CONTENT: {
            return stripHtml(result.content);
        }
        default: {
            return result.text;
        }
    }
};

export const getMatches = (
    needle: string,
    lookups: Array<Lookup>,
    limit?: number
): Array<Lookup> => {
    const results = [];
    let lookup;
    for (let i = 0; i < lookups.length; i++) {
        lookup = lookups[i];
        if (!needle) {
            results.push(lookup);
            if (limit && i > limit) {
                break;
            }
        } else if (
            fuzzyMatch(needle, lookup.title) ||
            fuzzyMatch(needle, lookup.content)
        ) {
            results.push(lookup);
            if (limit && i > limit) {
                break;
            }
        }
    }
    return results;

};



// WEBPACK FOOTER //
// ./src/vas/controls/text/form/text-control.helpers.ts